import { pick } from "rambda"
import { useMemo, useState } from "react"
import { ApiError } from "@shared/primitive-components"
import { Variables, FilterVehiclesResponse, useFilterVehicles } from "../../../../../../api/vehicles/filter"
import { AddedFleetEntry } from "../../../../../../api/fleet"
import { DropdownFieldComponent, DropdownFieldComponentProps } from "./DropdownFieldComponent"

type Props = Omit<DropdownFieldComponentProps, "dropdownValues" | "disabled"> & {
  entry: AddedFleetEntry
  prerequisiteFields: (keyof Variables)[]
  dataKey: keyof FilterVehiclesResponse
}

export const DropdownFieldComponentWithDataLoad = ({ entry, prerequisiteFields, dataKey, ...props }: Props) => {
  const [resultFilter, setResultFilter] = useState(``)
  const [res] = useFilterVehicles({
    variables: pick(prerequisiteFields, entry),
  })
  const dropdownValues = useMemo(
    () =>
      ((res.result?.data?.[dataKey] || []) as string[]).filter(
        (it: string) => !resultFilter || it.toLowerCase().includes(resultFilter.toLowerCase())
      ),
    [res.result?.data, resultFilter, dataKey]
  )

  if (res.result?.tag === `err`) {
    return <ApiError error={res.result.error.type} />
  }
  return (
    <DropdownFieldComponent
      {...props}
      dropdownValues={dropdownValues}
      onInputValueChange={setResultFilter}
      disabled={res.loading || !res?.result}
    />
  )
}
